import { z } from 'zod'

import ENDPOINTS from '@/config/http/endpoints'
import { parseResponse } from '@/config/http/http.helpers'
import { mapLoginResponse } from '@/ducks/auth/auth.helpers'
import {
  ApiLoginResponseSchema,
  ApiMeRolesResponse,
  ApiMeRolesResponseSchema
} from '@/ducks/auth/auth.types'
import { rootApi } from '@/ducks/root.api'

export const authApi = rootApi.injectEndpoints({
  endpoints: build => ({
    login: build.mutation<
      ReturnType<typeof mapLoginResponse>,
      { email: string; password: string }
    >({
      query: data => ({
        method: 'POST',
        url: ENDPOINTS.LOG_IN,
        noAuth: true,
        skipAuth: true,
        data
      }),
      transformResponse: (response: z.input<typeof ApiLoginResponseSchema>) => {
        const typedResponse = parseResponse(response, ApiLoginResponseSchema)
        return mapLoginResponse(typedResponse)
      }
    }),
    getMyRoles: build.query<ApiMeRolesResponse, { token?: string } | void>({
      query: params => ({
        method: 'GET',
        url: ENDPOINTS.ME_ROLES,
        // Backend expects raw Yacool JWT in Authorization (no Bearer prefix).
        headers: params?.token ? { Authorization: params.token } : undefined
      }),
      transformResponse: (response: ApiMeRolesResponse) =>
        parseResponse(response, ApiMeRolesResponseSchema)
    })
  })
})

// export const { useExampleQuery } = extendedApi
export const { useLoginMutation, useGetMyRolesQuery } = authApi
